<template>
  <div>
    <tripwiseHeader :type='3'></tripwiseHeader>
    <div class="banner">
      <img
        class="bannerBg"
        src="https://image.ceekee.com/pc/secondwebsite/business/cooperation_bg.png"
      />
    </div>
    <div class="content b-flex b-flex-row b-align-centenr b-justify-center">
      <img class="img1" src="https://image.ceekee.com/pc/secondwebsite/business/about_tripwise.png" />
      <div>
        <div class="title">关于Tripwise</div>
        <div class="detail b-flex b-flex-column">
          <span>Tripwise为苏州大管家信息科技有限公司旗下品牌</span>
          <span>成立于2016年，总部位于苏州工业园区金鸡湖畔，</span>
          <span>在苏州、上海、杭州、深圳设立分支机构，</span>
          <span>公司成立之初就获得初之心资本，</span>
          <span>点评创始人点亮基金、蕻郁资本，上市公司梦百合的多轮近亿元投资。</span>
        </div>
        <div class="detail b-flex b-flex-column">
          <span>提供预订及过程中的管控服务，包含差标管理、最低价管控和数据分析</span>
          <span>报表以及跨平台直连系统（OA\ERP\ 财务系统），全力赋能企业提高管</span>
          <span>理效率，降低差旅成本成本，提高员工满意，实现差旅费用支出的数字化管理。</span>
        </div>
      </div>
    </div>
    <div class="backgroud content b-flex b-flex-row b-align-centenr b-justify-center">
      <div>
        <div class="title">所获荣誉</div>
        <div class="detail b-flex b-flex-column">
          <span>2021企业服务狂欢节金奖</span>
          <span>2021企业服务类目销售冠军</span>
          <span>CTCS CHINA 2020年度最佳差旅管理公司</span>
          <span>国家高新技术企业-2019年获得国家高新技术企业</span>
          <span>创业创新大赛奖-智能科技分赛二等奖</span>
          <span>数十项专利技术-差旅管控、费控报销 数据分析、多供应商轮询</span>
          <span>江苏股权交易中心-2017年 股票代码: 900315</span>
          <span>2019年荣获苏州金鸡湖高端服务领军人才</span>
        </div>
      </div>
      <img class="img2" src="https://image.ceekee.com/pc/secondwebsite/business/about_rongyu.png" />
    </div>
    <div class="culture b-flex b-flex-row b-align-centenr b-justify-center">
      <img class="icon1" src="https://image.ceekee.com/pc/secondwebsite/business/yuan01.png" />
      <img class="icon2" src="https://image.ceekee.com/pc/secondwebsite/business/yuan02.png" />
      <div>
        <div class="title">企业文化</div>
        <div class="b-flex b-flex-row">
          <div class="item-type1">
            <div class="item-title">使命</div>
            <div class="b-flex b-flex-column b-justify-center">
              <span class="item-content b-flex b-justify-center">让企业的出行变得</span>
              <span class="item-content b-flex b-justify-center">更简单</span>
            </div>
          </div>
          <div class="item-type1">
            <div class="item-title">愿景</div>
            <div class="b-flex b-flex-column b-justify-center">
              <span class="item-content b-flex b-justify-center">成为企业出行领域</span>
              <span class="item-content b-flex b-justify-center">的基础设施</span>
            </div>
          </div>
          <div class="item-type2">
            <div class="item-title">价值观</div>
            <div class="b-flex b-flex-column b-justify-center">
              <span class="item-content">1）客户至上：为客户创造价值</span>
              <span class="item-content">2）以奋斗者为本：为员工实现梦想，创造超额回报</span>
              <span class="item-content">3）团结协作：为伙伴创造利益</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact backgrond b-flex b-flex-column b-align-centenr b-justify-center">
        <div class="title">联系我们</div>
        <div class="detail">公司地址：苏州工业园区思安街99号鑫能商务广场1幢20F</div>
        <div class="detail">深圳分公司：深圳市福田区金田路2030号卓越世纪中心1号楼35层</div>
        <div class="detail">商务合作：<span class="email">weilijun@tripwise.cn</span></div>
        <div class="detail">服务热线：400 900 5788</div>
    </div>
    <tripwiseBottom></tripwiseBottom>
  </div>
</template>

<script>
import tripwiseHeader from "@/components/header";
import tripwiseBottom from "@/components/bottom";
export default {
  components: {
    tripwiseHeader,
    tripwiseBottom
  }
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  overflow: hidden;
  position: relative;
  .bannerBg {
    width: 100%;
  }
}
.backgroud {
  background: #f7fbfe !important;
}
.content {
  background: #fff;
  padding: 218px 0 156px;
  .title {
    font-size: 40px;
    color: #181819;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 38px;
  }
  .detail {
    font-size: 18px;
    color: #666666;
    line-height: 26px;
    margin-bottom: 40px;
  }
  .img1 {
    width: 42.1%;
    margin-right: 56px;
  }
  .img2 {
    width: 38.8%;
    margin-left: 90px;
  }
}
.culture {
  padding: 280px 0;
  position: relative;
  background: #fff;
  .title {
    font-size: 40px;
    color: #181819;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 80px;
  }
  .item-type1 {
    width: 300px;
    height: 320px;
    background: #ffffff;
    box-shadow: 0px 32px 84px 0px rgba(14, 86, 124, 0.16);
    border-radius: 20px;
    padding: 40px;
    margin-right: 60px;
  }
  .item-title {
    background: #ffffff;
    font-size: 32px;
    color: #000000;
    letter-spacing: 2px;
    line-height: 32px;
    font-weight: 600;
    margin-bottom: 66px;
  }
  .item-type2 {
    width: 676px;
    height: 320px;
    background: #ffffff;
    padding: 40px;
    box-shadow: 0px 2px 4px 0px rgba(14, 86, 124, 0.16);
    border-radius: 20px;
  }
  .item-content {
    font-size: 24px;
    color: #666666;
    letter-spacing: 2px;
    line-height: 36px;
    font-weight: 600;
  }
  .icon1 {
    position: absolute;
    top: 0;
    right: 0;
    width: 20.5%;
  }
  .icon2 {
    position: absolute;
    left: 13.54%;
    bottom: 0;
    width: 17.3%;
  }

  @media screen and (max-width: 1400px) {
    .title {
    font-size: 36px;
    color: #181819;
    line-height: 36px;
    font-weight: 600;
    margin-bottom: 70px;
  }
    .item-type1 {
    width: 260px;
    height: 280px;
    background: #ffffff;
    box-shadow: 0px 32px 84px 0px rgba(14, 86, 124, 0.16);
    border-radius: 20px;
    padding: 30px;
    margin-right: 50px;
  }
  .item-title {
    background: #ffffff;
    font-size: 26px;
    color: #000000;
    letter-spacing: 2px;
    line-height: 26px;
    font-weight: 600;
    margin-bottom: 56px;
  }
  .item-type2 {
    width: 560px;
    height: 280px;
    background: #ffffff;
    padding: 30px;
    box-shadow: 0px 2px 4px 0px rgba(14, 86, 124, 0.16);
    border-radius: 20px;
  }
  .item-content {
    font-size: 20px;
    color: #666666;
    letter-spacing: 2px;
    line-height: 32px;
    font-weight: 600;
  }
  }
}
.contact {
  padding: 106px 0 76px;
  width: 100%;
  .title {
    font-size: 40px;
    color: #181819;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 38px;
  }
  .detail {
    font-size: 18px;
    color: #666666;
    line-height: 18px;
    font-weight: 600;
    margin-bottom: 12px;
    .email{
        color: #0376F7
    }
  }
}
</style>